import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaWhatsapp } from "react-icons/fa";

export default function Contact() {
  const phone = "8438237072";
  const email = "megamindbusinesssolutions@gmail.com";

  return (
    <section id="contact" className="py-16 px-4 bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-green-500/10 border border-green-500/20 rounded-full text-green-400 text-xs font-semibold tracking-wider uppercase mb-3">
            Get In Touch
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold">
            Let's Build Something{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-300">
              Amazing
            </span>
          </h2>
          <p className="mt-3 text-gray-400 text-sm sm:text-base max-w-2xl mx-auto">
            Have a project in mind? We'd love to hear from you. Let's create something extraordinary together.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left - Contact Info */}
          <div className="space-y-6">
            {/* Contact Cards */}
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:border-green-500/30 transition-all duration-300">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-green-500/20 flex items-center justify-center text-green-400 text-xl flex-shrink-0">
                  <FaPhone />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-gray-400">Phone</h3>
                  <a 
                    href={`tel:${phone}`}
                    className="text-lg font-medium hover:text-green-400 transition-colors"
                  >
                    +91 {phone}
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:border-green-500/30 transition-all duration-300">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-blue-500/20 flex items-center justify-center text-blue-400 text-xl flex-shrink-0">
                  <FaEnvelope />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-gray-400">Email</h3>
                  <a 
                    href={`mailto:${email}`}
                    className="text-lg font-medium hover:text-green-400 transition-colors break-all"
                  >
                    {email}
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:border-green-500/30 transition-all duration-300">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-purple-500/20 flex items-center justify-center text-purple-400 text-xl flex-shrink-0">
                  <FaClock />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-gray-400">Working Hours</h3>
                  <p className="text-lg font-medium">Mon - Sat: 10:00 AM - 7:00 PM</p>
                  <p className="text-sm text-gray-400">Sunday: Closed</p>
                </div>
              </div>
            </div>

            {/* WhatsApp CTA */}
            <a
              href={`https://wa.me/${phone}?text=${encodeURIComponent(
                "Hi! I'd like to discuss a project with you.",
              )}`}
              target="_blank"
              rel="noreferrer"
              className="block"
            >
              <div className="bg-gradient-to-r from-green-500 to-emerald-600 rounded-2xl p-6 flex items-center justify-between hover:scale-105 transition-all duration-300 shadow-lg shadow-green-500/20">
                <div className="flex items-center gap-3">
                  <FaWhatsapp className="text-3xl" />
                  <div>
                    <h3 className="font-semibold">Chat on WhatsApp</h3>
                    <p className="text-sm text-white/80">Quick response in 24hrs</p>
                  </div>
                </div>
                <span className="text-2xl">→</span>
              </div>
            </a>
          </div>

          {/* Right - Form */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 sm:p-8">
            <h3 className="text-2xl font-bold mb-6">Send a Message</h3>
            
            <form className="space-y-4">
              <div>
                <label className="block text-sm text-gray-400 mb-1">Full Name</label>
                <input
                  type="text"
                  placeholder="Your full name"
                  className="w-full px-4 py-3 bg-white/10 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:border-green-500 focus:outline-none transition-colors"
                />
              </div>

              <div>
                <label className="block text-sm text-gray-400 mb-1">Email Address</label>
                <input
                  type="email"
                  placeholder="you@example.com"
                  className="w-full px-4 py-3 bg-white/10 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:border-green-500 focus:outline-none transition-colors"
                />
              </div>

              <div>
                <label className="block text-sm text-gray-400 mb-1">Subject</label>
                <input
                  type="text"
                  placeholder="What's this about?"
                  className="w-full px-4 py-3 bg-white/10 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:border-green-500 focus:outline-none transition-colors"
                />
              </div>

              <div>
                <label className="block text-sm text-gray-400 mb-1">Message</label>
                <textarea
                  placeholder="Tell us about your project..."
                  rows="4"
                  className="w-full px-4 py-3 bg-white/10 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:border-green-500 focus:outline-none transition-colors resize-none"
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full py-3.5 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-xl font-semibold hover:shadow-lg hover:shadow-green-500/30 hover:scale-[1.02] transition-all duration-300"
              >
                Send Message →
              </button>
            </form>

            <p className="text-xs text-center text-gray-500 mt-4">
              We'll get back to you within 24 hours
            </p>
          </div>
        </div>

        {/* Bottom - Trust Badges */}
        <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
          <div className="bg-white/5 border border-white/10 rounded-xl p-4">
            <span className="text-2xl block mb-1">🛡️</span>
            <p className="text-xs text-gray-400">Secure & Confidential</p>
          </div>
          <div className="bg-white/5 border border-white/10 rounded-xl p-4">
            <span className="text-2xl block mb-1">⚡</span>
            <p className="text-xs text-gray-400">Fast Response</p>
          </div>
          <div className="bg-white/5 border border-white/10 rounded-xl p-4">
            <span className="text-2xl block mb-1">💎</span>
            <p className="text-xs text-gray-400">Quality Guaranteed</p>
          </div>
          <div className="bg-white/5 border border-white/10 rounded-xl p-4">
            <span className="text-2xl block mb-1">🌟</span>
            <p className="text-xs text-gray-400">5-Star Support</p>
          </div>
        </div>
      </div>
    </section>
  );
}